<div *ngIf="temDependentes" class="row align-items-center">

    <div class="col"></div>

    <div *ngIf="pacienteAtual" class="col d-flex justify-content-center paciente-atual">
        <span class="paciente-chip">
            <i class="fas fa-user-circle"></i>
            Selecionado:
            <strong>{{ pacienteAtual.nome }}</strong>

            <button *ngIf="pacienteInicial && pacienteAtual.id !== pacienteInicial.id" class="btn-voltar-paciente"
                (click)="voltarPaciente.emit()" title="Voltar para meus dados">
                <i class="fas fa-undo-alt"></i>
            </button>
        </span>
    </div>

    <div class="col d-flex justify-content-end">
        <button class="btn btn-dependente" (click)="selecionarDependente.emit()">
            <i class="fas fa-user-friends"></i>
            Selecionar dependente
        </button>
    </div>

</div>